// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"style_menuItem__yByl6","scrollbarMobile":"style_scrollbarMobile__2H8xf","icon":"style_icon__2mn5u"};